import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import * as Classes from '../../common/classes';
import { Checkbox as CheckboxCore } from '../../checkbox/Checkbox';
import { Field } from '../Field';
import { FormItem } from './FormItem';
import classNames from 'classnames';
import { MFieldProps } from '../types';
import { DATA_FORM_INPUT } from '../../common/data';

export type CheckboxProps = MFieldProps<
  React.ComponentProps<typeof CheckboxCore>
> & {
  label?: string;
  /**
   * Má mít checbox stejnou výšku jako input? Typické použití je v případě, že je na řádku vedle sebe input a checkbox.
   */
  inputHeight?: boolean;
  inlineValidation?: boolean;
};
export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      name,
      indeterminate,
      validate,
      className,
      inputClassName,
      contentClassName,
      inlineValidation,
      disabled,
      required,
      label,
      title,
      inputHeight,
      ...other
    },
    ref
  ) => {
    if (indeterminate) {
      return (
        <FormItem
          label={false}
          inlineValidation={inlineValidation}
          inlineValidationFitContent={inlineValidation}
          name={name}
          className={classNames(Classes.FORM_CHECKBOX_ITEM, className, {
            [Classes.FORM_CHECKBOX_INPUT_ITEM]: inputHeight,
          })}
          disabled={disabled}
          required={required}
          contentClassName={contentClassName}
        >
          <Field name={name}>
            {({
              input: { onChange, value },
              meta,
            }: FieldRenderProps<boolean>) => {
              return (
                <CheckboxCore
                  {...DATA_FORM_INPUT(name)}
                  {...other}
                  title={title}
                  disabled={disabled || meta.submitting}
                  className={classNames(className)}
                  onChange={(x) => {
                    // @ts-ignore
                    onChange({ target: { name, value: x.target.checked } });
                  }}
                  indeterminate={(value as any) === '' || value === undefined}
                  checked={
                    (value as any) === '' || value === undefined
                      ? undefined
                      : value
                  }
                  // @ts-ignore
                  label={
                    <span
                      tabIndex={disabled ? undefined : -1}
                      className={classNames(
                        Classes.LABEL_MAYBE_REQUIRED,
                        Classes.CHECKBOX_LABEL
                      )}
                      title={title}
                      onClick={() => {
                        // @ts-ignore
                        !disabled &&
                          onChange({ target: { name, value: !value } });
                      }}
                    >
                      {label}
                      <span> </span>
                    </span>
                  }
                  // @ts-ignore
                  ref={ref}
                />
              );
            }}
          </Field>
        </FormItem>
      );
    } else {
      return (
        <FormItem
          label={false}
          inlineValidation={inlineValidation}
          inlineValidationFitContent={inlineValidation}
          name={name}
          className={classNames(Classes.FORM_CHECKBOX_ITEM, className, {
            [Classes.FORM_CHECKBOX_INPUT_ITEM]: inputHeight,
          })}
          disabled={disabled}
          required={required}
        >
          <Field name={name} type="checkbox">
            {({ input: { checked, onChange } }: FieldRenderProps<boolean>) => {
              return (
                <CheckboxCore
                  {...DATA_FORM_INPUT(name)}
                  {...other}
                  title={title}
                  disabled={disabled}
                  className={classNames(className)}
                  onChange={onChange}
                  checked={checked}
                  // @ts-ignore
                  label={
                    <span
                      tabIndex={disabled ? undefined : -1}
                      onClick={() => {
                        // @ts-ignore
                        !disabled &&
                          onChange({ target: { name, value: !checked } });
                      }}
                      title={title}
                      className={classNames(
                        Classes.LABEL_MAYBE_REQUIRED,
                        Classes.CHECKBOX_LABEL
                      )}
                    >
                      {label}
                      <span> </span>
                    </span>
                  }
                  // @ts-ignore
                  ref={ref}
                />
              );
            }}
          </Field>
        </FormItem>
      );
    }
  }
);
